/**
 * Feature toggles that must default to DISABLED (unchecked) in the role/profile editors when a role or
 * profile has no saved value for them yet — the opposite of the usual "default enabled". Newer / opt-in
 * features go here so they stay off until an admin explicitly turns them on, in both profiles and roles.
 */
export const DEFAULT_DISABLED_FEATURES: string[] = [
    'claudy-feature',
    // Claudy in the app is opt-in per role (owner D2); claudy-query/edit/delete/actions default ON (D1) so they are not listed.
    'claudy-mobile'
];

/** Keys that default OFF on a role but ON on a tenant profile (a profile only caps what its roles may enable). */
export const PROFILE_DEFAULT_ENABLED_FEATURES: string[] = ['claudy-mobile'];

export type FeatureScope = 'role' | 'profile';

/** Default visibility for a feature id when it is absent from the saved settings map. */
export const defaultFeatureVisible = (id: string, scope: FeatureScope = 'role'): boolean =>
    scope === 'profile' && PROFILE_DEFAULT_ENABLED_FEATURES.includes(id) ? true : !DEFAULT_DISABLED_FEATURES.includes(id);
